export class NetworkError extends Error {
  status?: number;
  body?: NetworkErrorBody;

  constructor(status?: number, data?: NetworkErrorBody) {
    super();
    this.status = status;
    if (data && data.tag && data.code && Array.isArray(data.args)) {
      this.body = { tag: data.tag, code: data.code, args: data.args };
    }
  }
}

export interface NetworkErrorBody {
  tag: string;
  code: string;
  args: string[];
}
